<template>
  <div class="FATCA">
    <div class="row q-pa-sm">
      <div class="col-12 col-md-6 ">
        <div rounded class="">
          <!-- 	<q-field  :label='$t("Fatca-Detail.declaration")' readonly orientation="vertical"></q-field>
				<div class="row">
					<div class="col-12">
						<q-item multiline tag="label">
							<q-item>
								<q-toggle
									v-model="StoreStateFATCA.PersonalAsset"
                  :readonly="$route.name==='Application Details'"
								/>
							</q-item>
							<q-item-section>
								<q-item-label sublabel lines="20" style="color:black;">{{$t("Fatca-Detail.netpersonal") }}</q-item-label>
							</q-item-section>
						</q-item>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<q-item multiline tag="label">
							<q-item>
								<q-toggle
									v-model="StoreStateFATCA.SophisticatedInvestor"
                  :readonly="$route.name==='Application Details'"
								/>
							</q-item>
							<q-item-section>
								<q-item-label sublabel lines="20" style="color:black;">{{$t("Fatca-Detail.sophisticated.title")}}
                                     
									<q-btn round size="xs" color="blue" icon="fas fa-info" class="" v-if="$route.name!=='Application Details'">
										<q-menu>
											<q-list link separator class="scroll" style="min-width: 100px">
												<q-list overline>
													<b>{{$t("Fatca-Detail.sophisticated.question")}}</b>
												</q-list>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">1.	 {{$t("Fatca-Detail.sophisticated.info1")}} </q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">2.	 {{$t("Fatca-Detail.sophisticated.info2")}} </q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">3.	 {{$t("Fatca-Detail.sophisticated.info3")}} </q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">4.	 {{$t("Fatca-Detail.sophisticated.info4")}}</q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">5.	 {{$t("Fatca-Detail.sophisticated.info5")}} </q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">6.	 {{$t("Fatca-Detail.sophisticated.info6")}}</q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">7.	 {{$t("Fatca-Detail.sophisticated.info7")}} </q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">8.	 {{$t("Fatca-Detail.sophisticated.info8")}} </q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">9.  {{$t("Fatca-Detail.sophisticated.info9")}} </q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">10.  {{$t("Fatca-Detail.sophisticated.info1")}} </q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">11.  {{$t("Fatca-Detail.sophisticated.info11")}}</q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">12.  {{$t("Fatca-Detail.sophisticated.info12")}}</q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">13.  {{$t("Fatca-Detail.sophisticated.info13")}}</q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">14.  {{$t("Fatca-Detail.sophisticated.info14")}} </q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">15.  {{$t("Fatca-Detail.sophisticated.info1")}} </q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">16.  {{$t("Fatca-Detail.sophisticated.info16")}}</q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">17.  {{$t("Fatca-Detail.sophisticated.info17")}} </q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">18.  {{$t("Fatca-Detail.sophisticated.info18")}} </q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">19.  {{$t("Fatca-Detail.sophisticated.info19")}}</q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">20.  {{$t("Fatca-Detail.sophisticated.info20")}}</q-item-section>
												</q-item>
												<q-item clickable v-close-popup>
													<q-item-section sublabel lines="20" style="color:black;">21  {{$t("Fatca-Detail.sophisticated.info21")}} </q-item-section>
												</q-item>
											</q-list>
										</q-menu>
									</q-btn>
								</q-item-label>
							</q-item-section>
						</q-item>
					</div>
				</div> -->
          <!-- <div class="row">
					<div class="col-12">
						<q-item multiline tag="label">
							<q-item>
								<q-toggle
									v-model="StoreStateFATCA.PEP"
                  :readonly="$route.name==='Application Details'"
								/>
							</q-item>
							<q-item-section>
								<q-item-label sublabel lines="20" style="color:black;">{{$t("Fatca-Detail.family")}}</q-item-label>
							</q-item-section>
						</q-item>
						<q-list v-if="StoreStateFATCA.PEP===true" no-border>
							<div class="row">
								<div class="col-12">
									<q-input filled lazy-rulesss :rules="[val => !!val || 'Field is required']" v-model="StoreStateFATCA.PEPPosition" :label='$t("Fatca-Detail.pepposition")'  :readonly="$route.name==='Application Details'"/>
								</div>
							</div>
							<div class="row">
								<div class="col-12">
									<q-input filled lazy-rulesss :rules="[val => !!val || 'Field is required']" v-model="StoreStateFATCA.PEPRelationship" :label='$t("Fatca-Detail.peprelationship")'  :readonly="$route.name==='Application Details'"/>
								</div>
							</div>
						</q-list>
					</div>
				</div> -->

          <div class="row">
            
              <!-- <q-field readonly :label='$t("Fatca-Detail.fatcadeclaration")' orientation="vertical"></q-field> -->
              <b>{{ $t("Fatca-Detail.fatcadeclaration") }}</b>
			  <div class="q-py-sm" style="border: 1px solid #c2c2c2; border-radius: 0.5rem; margin-bottom: 20px; width: 100%; padding: 8px 0px !important;">
              <q-item
                multiline
                v-for="usres in StoreStateLookup.USResident_LK"
                v-bind:key="usres.index"
				class="q-pa-none"
              >
                
                  <q-item-section avatar>
                    <q-radio
                      checked-icon="radio_button_checked"
                      unchecked-icon="radio_button_unchecked"
                      color="teal-14"
                      v-model="StoreStateFATCA.UsResident"
                      :val="usres.value"
                      :readonly="$route.name === 'Application Details'"
                    />
                  </q-item-section>
                
                <q-item-section>
                  <q-item-label sublabel lines="20" style="color: black">{{
                    usres.label
                  }}</q-item-label>
                </q-item-section>
              </q-item>
              
			  </div>

				<!-- if 'Non-US Person with US Indicia' selected -->
			  <q-list
                link
                
                v-if="StoreStateFATCA.UsResident == '03'"
				style="border: 1px solid #c2c2c2; border-radius: 0.5rem; margin-bottom: 20px; width: 100%;  margin-left: 0px; vertical-align: middle; padding: 8px 0px !important;"
              >
                
                    <q-item
                      multiline
                      
                      v-for="indi in StoreStateLookup.UsResidentIndicia_LK"
                      v-bind:key="indi.index"
					  class="q-pa-none"
                    >
                      
                        <q-item-section avatar>
                          <q-checkbox
                            checked-icon="check_box"
                            unchecked-icon="check_box_outline_blank"
                            color="teal-14"
                            v-model="StoreStateFATCA.UsResidentIndicia"
                            :val="indi.value"
                            :readonly="$route.name === 'Application Details'"
                          />
                        </q-item-section>
                      
                      <q-item-section>
                        <q-item-label
                          sublabel
                          lines="20"
                          style="color: black"
                          >{{ indi.label }}</q-item-label
                        >
                      </q-item-section>
                    </q-item>
                  
              </q-list>
            
          </div>
        </div>
      </div>

	  <!-- Tax Residency -->
      <div class="col-12 col-md-6">
        <div rounded class="">
          <div class="row">
            
              <b>{{ $t("Fatca-Detail.taxresidency") }}</b>
            
              <!-- <q-field :label='$t("Fatca-Detail.taxresidency")' readonly orientation="vertical"></q-field> -->
			<div class="q-py-sm" style="border: 1px solid #c2c2c2; border-radius: 0.5rem; margin-bottom: 20px; width: 100%; padding: 8px 0px !important;">
              <q-item
                multiline
                v-for="tax in StoreStateLookup.TaxResidency_LK"
                v-bind:key="tax.index"
				class="q-pa-none"
              >
                
                  <q-item-section avatar>
                    <q-radio
                      checked-icon="radio_button_checked"
                      unchecked-icon="radio_button_unchecked"
                      color="teal-14"
                      v-model="StoreStateFATCA.TaxResidency"
                      :val="tax.value"
                      :readonly="$route.name === 'Application Details'"
                    />
                  </q-item-section>
               
                <q-item-section>
                  <q-item-label sublabel lines="20" style="color: black">{{
                    tax.label
                  }}</q-item-label>
                </q-item-section>
              </q-item>
			  </div>
            </div>
          </div>
         
			<!-- TIN -->
          <div
            class="row"
            v-if="
              StoreStateFATCA.TaxResidency == 3 ||
              StoreStateFATCA.TaxResidency == 2"
          >
		  <b>{{ $t("Fatca-Detail.tindetails") }}</b>
            <div class="col-12" style="border: 1px solid #c2c2c2; border-radius: 0.5rem; margin-bottom: 20px; width: 100%;">
              <!-- <p class="caption">{{ $t("Fatca-Detail.tindetails") }}</p> -->
              
              <q-table
                grid
                hide-header
                :data="StoreStateFATCA.TaxResidencyTIN"
                :columns="columns"
                :filter="filter"
                :selection="selection"
                :selected.sync="selected"
                :visible-columns="visibleColumns"
                :pagination.sync="pagination"
                row-key="Id"
              >
                <!-- <template slot="top"><q-btn color="primary" icon="add_box" @click="TINModal=true" label="TIN" push v-if="$route.name!=='Application Details'"/></template> -->
                <div
                  slot="item"
                  slot-scope="props"
                  class="q-pa-none"
				  style="padding: 0px 0px !important; width: 100%;"
                >
                  <div class="cursor-pointer" style="border: 1px solid #c2c2c2; border-radius :0.5rem;">
                    <!-- <div class="col-12 text-bold" style="padding: 31px 31px 0.75rem;">
                        {{props.row.TaxResidency_CountryName}}
					</div> -->
                    
                    <div class="col-12 q-pa-none">
                      <q-list no-border>
						  <q-item multiline class="q-py-none" style="">
                          <q-item-section class="q-pb-none" style="padding-bottom: 0px !important; padding-top: 0px !important; margin: 15px 0px 10px;">
							  <b>{{props.row.TaxResidency_CountryName}}</b>
							  </q-item-section>
                        </q-item>
                        <q-item multiline class="q-py-none" style="">
                          <q-item-section class="q-pb-none" style="padding-bottom: 0px !important; padding-top: 0px !important;">
                            <q-item-label sublabel>
								{{$t("Fatca-Detail.tinunavailable")}}
							</q-item-label>
                          </q-item-section >
                          <q-item-section right class="q-pb-none" style="padding-bottom: 0px !important; padding-top: 0px !important;">
                            <q-item-label sublabel lines="5">{{
                              props.row.TaxResidency_IsTINUnavailable
                                | FormatTrueFalse
                            }}</q-item-label>
                          </q-item-section>
                        </q-item>
                        <q-item
						class="q-py-none"
                          multiline
                          v-if="
                            props.row.TaxResidency_IsTINUnavailable === false"
                        >
                          <q-item-section class="q-pb-none" style="padding-bottom: 0px !important; padding-top: 0px !important;">
                            <q-item-label sublabel>TIN</q-item-label>
                          </q-item-section>
                          <q-item-section right class="q-pb-none" style="padding-bottom: 0px !important; padding-top: 0px !important;">
                            <q-item-label sublabel lines="5">{{
                              props.row.TaxResidency_TIN
                            }}</q-item-label>
                          </q-item-section>
                        </q-item>
                        <q-item
						class="q-py-none"
                          multiline
                          v-if="
                            props.row.TaxResidency_IsTINUnavailable === true"
                        >
                          <q-item-section style="padding-bottom: 0px !important; padding-top: 0px !important;">
                            <q-item-label sublabel>
								{{ $t("Fatca-Detail.reason")}}</q-item-label>
                          </q-item-section>
                          <q-item-section right style="padding-bottom: 0px !important; padding-top: 0px !important;">
                            <q-item-label sublabel lines="5">{{
                              props.row.TaxResidency_UnavailableReason
                            }}</q-item-label>
                          </q-item-section>
                        </q-item>
                        <q-item
						class="q-py-none"
                          multiline
                          v-if="
                            props.row.TaxResidency_IsTINUnavailable === true &&
                            props.row.TaxResidency_UnavailableReason === 'B'"
                        >
                          <q-item-section style="padding-bottom: 0px !important; padding-top: 0px !important;">
                            <q-item-label sublabel
                              >{{ $t("Fatca-Detail.reasonb") }}
                            </q-item-label>
                          </q-item-section>
                          <q-item-section right style="padding-bottom: 0px !important; padding-top: 0px !important;">
                            <q-item-label sublabel lines="5">{{
                              props.row.TaxResidency_ReasonB
                            }}</q-item-label>
                          </q-item-section>
                        </q-item>
                      </q-list>
                    </div>

					<div class="col-12" style="padding: 0.75rem; text-align: right;">
                            <q-btn
							  outline
							  unelevated
                              color="GREY"
                              size="md"
                              class="q-ml-sm"
                              label="Edit"
                              @click="UpdateTIN(props.row.Id)"
                              v-if="$route.name !== 'Application Details'"
                            />

                            <q-btn
							  outline
                              color="red-12"
                              size="md"
                              class="q-ml-sm"
                              label="Remove"
                              @click="deleteTIN(props.row.Id)"
                              v-if="$route.name !== 'Application Details'"
                            />
                          </div>

                  </div>
                </div>
              </q-table>

			  <q-btn
			  	unelevated
				outline
                class=""
                color="tertiary"
                text-color="primary"
                icon="add"
                @click="AddNewTIN()"
                label="TIN"
                v-if="$route.name !== 'Application Details'"
				style="width: 100%; margin-top: 10px; margin-bottom: 5px;"
              />

              <q-dialog
                persistent
                transition-show="scale"
                transition-hide="scale"
                v-model="TINModal"
                :content-css="{ minWidth: '50vw' }"
              >
                <q-card style="min-width: 350px">
                  <q-card-section>
                    <div style="padding: 16px;">
                      
                        <div class="text-bold" style="margin-bottom: 32px !important; font-size: 16px;">{{ $t("Fatca-Detail.addnewtin") }}</div>
                      
                      
                      <FAT
                        :TINModal="TINModal"
                        @updateTINModal="UpdateFalseTINModal"
                        Status="New"
                        ref="fatNew"
                      ></FAT>
                    </div>
                  </q-card-section>
                </q-card>
              </q-dialog>
              <q-dialog
                persistent
                transition-show="scale"
                transition-hide="scale"
                v-model="UpdateTINModal"
                :content-css="{ minWidth: '50vw' }"
              >
                 <q-card style="min-width: 350px">
                  <q-card-section>
                    <div style="padding: 16px;">
                        <div class="text-bold" style="margin-bottom: 32px !important; font-size: 16px;">{{ $t("Fatca-Detail.updatetin") }}</div>

                      <FAT
                        :UpdateTINModal="UpdateTINModal"
                        @updateStatusUpdateTINModal="UpdateFalseUpdateTINModal"
                        Status="Update"
                        :SelectedTINId="SelectedTINId"
                        ref="fat"
                      ></FAT>
                    </div>
                  </q-card-section>
                </q-card>
              </q-dialog>
            </div>
          </div>
        </div>
      </div>
    
  </div>
</template>

<style lang="stylus" scoped>
.row > div {
  padding: 10px 15px
}
</style>

<style >
.d-option-group {
  border-radius: 0.5rem !important;
  border: 1px solid rgba(0, 0, 0, 0.24);
  margin-bottom: 20px;
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding: 0.75rem 0.5rem;
}

.q-item__section.column.q-item__section--avatar.q-item__section--side.justify-center {
    padding-right: 0px !important;
}
</style>

<script>
import FAT from "./FATCA_AddNewTIN";
import store from "../store";
import LookUp from "../assets/json/FieldsLookUp.json";
export default {
  name: "FATCA",
  components: {
    FAT,
  },
  props: {},
  data() {
    return {
      StoreStateFATCA: store.state.FATCA,
      StoreStateLookup: store.state.Lookup,
      TaxResidency_UnavailableReason: LookUp.TaxResidency_UnavailableReason,
      columns: store.state.FATCA.Columns,
      filter: "",
      visibleColumns: store.state.FATCA.VisibleColumns,
      separator: "horizontal",
      selection: "multiple",
      selected: [],
      pagination: {
        page: 1,
        rowsPerPage: 1,
      },
      paginationControl: { rowsPerPage: 1, page: 1 },
      loading: false,
      dark: true,
      selectedSecond: [],
      TINModal: false,
      UpdateTINModal: false,
      Status: "", //New or Update
      SelectedTINId: "",
    };
  },
  watch: {
    "paginationControl.page"(page) {
      this.$q.notify({
        color: "secondary",
        message: `Navigated to page ${page}`,
        actions:
          page < 1
            ? [
                {
                  label: "Go to last page",
                  handler: () => {
                    this.paginationControl.page = 1;
                  },
                },
              ]
            : null,
      });
    },
  },
  methods: {
    AddNewTIN() {
      this.TINModal = true;
    },
    UpdateTIN(id) {
      this.UpdateTINModal = true;
      var vm = this;
      setTimeout(function () {
        vm.$refs.fat.Get_TIN(id);
      }, 700);
    },
    deleteTIN(Id) {
      store.commit("Delete_TIN", Id);
    },
    UpdateFalseTINModal(value) {
      this.TINModal = value;
    },
    UpdateFalseUpdateTINModal(value) {
      this.UpdateTINModal = value;
    },
    SaveChangesFATCA() {
      this.$store.dispatch("PostApp_FATCA");
    },
  },
  computed: {},
  filters: {
    FormatDate: function (value) {
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      var NewDate = new Date();
      NewDate = date.formatDate(value, "DD-MMM-YYYY");
      if (value === null) {
        return "-";
      } else {
        return NewDate;
      }
    },
    FormatAmount: function (value) {
      if (
        value !== "" ||
        value !== undefined ||
        value !== 0 ||
        value !== "0" ||
        value !== ""
      ) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return value;
      }
    },
    FormatTrueFalse: function (value) {
      if (value !== "" || value !== undefined) {
        if (value === true) {
          return "Yes";
        } else if (value === false) {
          return "No";
        }
      } else {
        return value;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>